import View from './view';

export const ProfileApplicationsItemDesktop = View;
